<template>
    <div class="mp-servicee">
        <div class="tabs">
            <div class="tab" :class="{active:i==0}" v-for="(item,i) in options" :key="item.value">
                {{ item.label }}
            </div>
        </div>
        <div class="card"></div>
        <div class="card"></div>
        <div class="card"></div>
    </div>
</template>

<script>
export default {
    name: "MpService",
    props: {
        serviceSort: String
    },
    data() {
        return {
            
        }
    },
    computed:{
        options() {
            let arr = [];
            let options = this.serviceSort.split(',');
            options.forEach(item => {
                arr.push({
                    value:item,
                    label: {serve: '服务', courses: '课程', activity: '活动'}[item]
                });
            });
            return arr;
        }
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="less">
.mp-servicee {
   width: 100%;
   height: calc(100% - 55px);
   background: #fff; 
   padding: 30px 15px;
}

.tabs{
    display: flex;
    align-items: center;
}

.tab{
    color: #999999;
    font-size: 14px;
    margin-right: 10px;
}
.tab.active{
    color: #333333;
    font-size: 16px;
    font-weight: bold; 
}
.card{
    width: 100%;
    height: 100px;
    border-radius: 8px;
    background: #f2f2f2;
    margin-top: 12px;
}
</style>